enum GatewayTypeConstants {
  UNDEFINED = 'UNDEFINED',
  STATIONARY = 'STATIONARY',
  MOBILE = 'MOBILE',
  FLEET = 'FLEET',
}

export default GatewayTypeConstants;
